<template>
  <div class="card" v-if="result.notices">
    <div class="card-header">Notices</div>
    <div class="card-body">
      <table class="table">
        <tbody>
          <tr v-for="(notice, index) in result.notices" :key="notice.title">
            <th scope="row" width="120px">{{notice.title}}</th>
            <td>
              <p v-for="line in notice.description" :key="line">{{line}}</p>
              <p v-for="link in notice.links" :key="link.href">
                <a
                  :rel="link.rel"
                  :href="link.href"
                  class="query"
                  id="link"
                  target="_blank"
                >{{link.href}}</a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
	props: ["result"]
};
</script>

<style scoped lang="scss">
tbody tr:first-child {
	th,
	td {
		border-top: none;
	}
}
</style>
